import { Component, Inject, Input, OnInit } from '@angular/core';
import { LabelingReviewDrawingService } from '@features/labeling/labeling-task-review/services/labeling-review-drawing.service';
import { LabelingTaskPrivileges } from '@features/labeling/labeling.component';
import { createFromRegion } from "@features/labeling/models/annotation-group";
import { NamedEntityExtractionUILabel, ObjectDetectionUILabel } from '@features/labeling/models/label';
import { LabelingDrawingService } from '@features/labeling/object-detection-image-canvas/labeling-drawing.service';
import { LabelingService } from '@features/labeling/services/labeling.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { cloneDeep } from 'lodash';
import { combineLatest, Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { LabelingTask, ReviewRecordInfo, TextLabelingRecord } from "src/generated-sources";
import { LabelingReviewAnnotationGroupService } from '../services/labeling-review-annotation-group.service';
import { LabelingReviewService } from '../services/labeling-review.service';
import { LabelingReviewUpdateService } from '../services/labeling-review-update.service';

@UntilDestroy()
@Component({
    selector: 'review-image',
    templateUrl: './review-image.component.html',
    styleUrls: [
        './review-image.component.less',
        '../../shared-styles/annotation.less'
    ],
    providers: [
        { provide: LabelingDrawingService, useClass: LabelingReviewDrawingService }
    ]
})
export class ReviewImageComponent implements OnInit {
    @Input() privilegesOnTask: LabelingTaskPrivileges;
    currentImagePath$: Observable<string | null>;
    itemId$: Observable<string>;
    error$ = this.labelingService.getError();
    ObjectDetectionUILabel = ObjectDetectionUILabel;
    NamedEntityExtractionUILabel = NamedEntityExtractionUILabel;
    readonly LabelingTaskType = LabelingTask.LabelingTaskType;
    readonly ReviewRecordInfo: ReviewRecordInfo;
    readonly TextLabelingRecord: TextLabelingRecord;

    constructor(public labelingReviewService: LabelingReviewService,
        public labelingReviewAnnotationGroupService: LabelingReviewAnnotationGroupService,
        public labelingReviewUpdateService: LabelingReviewUpdateService,
        public labelingService: LabelingService,
        @Inject('$state') public $state: any
    ) { }

    ngOnInit(): void {
        this.itemId$ = this.labelingReviewService.currentId$.pipe(switchMap(itemId => this.labelingService.getItemId(itemId!)));

        this.labelingReviewService.first();

        combineLatest([
            this.labelingReviewService.currentReviewRecord$,
            this.labelingService.labelingTaskInfo$
        ]).pipe(
            untilDestroyed(this),
            filter(([record, _]) => record != null),
            map(([record, task]) =>
                record.regions.map(region => createFromRegion(region, task))
            )
        ).subscribe((annotationGroupList) => {
            this.labelingReviewAnnotationGroupService.annotationGroupList$.next(annotationGroupList);
            this.labelingReviewAnnotationGroupService.fetchedAnnotationGroupList$.next(cloneDeep(annotationGroupList));
        })
    }
}
